import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL } from "../constants/URL";

//GET STUDENT LIST
export const getTerminalFiles =
  (year, gradeId, shiftId, batchId, term) => async (dispatch) => {
    try {
      const data = {
        year,
        batchId,
        gradeId,
        shiftId,
        year,
        term,
      };
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const res = await axios.post(
        `${BASE_URL}/api/terminal-file/get`,
        JSON.stringify(data),
        config
      );

      return res.data.data;
    } catch (err) {
      toast.error(err.response.data.message);
      return false;
    }
  };

//GET STUDENT LIST
export const getIndividualTerminalFiles =
  (year, gradeId, shiftId, batchId, uid) => async (dispatch) => {
    try {
      const data = {
        year,
        batchId,
        gradeId,
        shiftId,
        year,
        uid,
      };
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const res = await axios.post(
        `${BASE_URL}/api/terminal-file/individual`,
        JSON.stringify(data),
        config
      );

      return res.data.data;
    } catch (err) {
      toast.error(err.response.data.message);
      return false;
    }
  };
//GET STUDENT LIST
export const getTerminalFileStudentList =
  (year, gradeId, shiftId, batchId, term) => async (dispatch) => {
    try {
      const data = {
        year,
        batchId,
        gradeId,
        shiftId,
        year,
        term,
      };
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const res = await axios.post(
        `${BASE_URL}/api/terminal-file/students`,
        JSON.stringify(data),
        config
      );

      return res.data.data;
    } catch (err) {
      toast.error(err.response.data.message);
      return false;
    }
  };

// Submit File
export const submitTerminalFile =
  (initData, file, uid, studentId) => async (dispatch) => {
    try {
      const data = new FormData();
      if (initData.grade) {
        data.append("gradeId", initData.grade);
      } else {
        toast.error("Class not found");
        return;
      }
      if (initData.shift) {
        data.append("shiftId", initData.shift);
      } else {
        toast.error("Shift not found");
        return;
      }
      if (initData.batch) {
        data.append("batchId", initData.batch);
      } else {
        toast.error("Batch not found");
        return;
      }
      if (studentId) {
        data.append("studentId", studentId);
      } else {
        toast.error("Student ID not found");
        return;
      }
      if (initData.year) {
        data.append("year", initData.year);
      } else {
        toast.error("Year not found");
        return;
      }
      if (initData.term) {
        data.append("term", initData.term);
      } else {
        toast.error("Term not found");
        return;
      }
      if (uid) {
        data.append("uid", uid);
      } else {
        toast.error("UID not found");
        return;
      }
      if (file) {
        data.append("file", file);
      } else {
        toast.error("File not found");
        return;
      }
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      const res = await axios.post(
        `${BASE_URL}/api/terminal-file/`,
        data,
        config
      );

      return res.data.data;
    } catch (err) {
      toast.error(err.response.data.message);
      return false;
    }
  };

export const deleteTerminalFile = (id) => async (dispatch) => {
  try {
    const res = await axios.delete(`${BASE_URL}/api/terminal-file/${id}`);

    return res.data.data;
  } catch (err) {
    toast.error(err.response.data.message);
    return false;
  }
};
